import * as React from 'react'

type Props = { children: React.ReactNode[] } & React.HTMLAttributes<HTMLDivElement>

export default function ContainerHiddenWithoutChildrenComponent (props: Props) {
  if (!props.children.find(Boolean)) return null
  return <div { ...props }></div>
}
